<template>
  <div class="header" v-if="tb">
    <div class="header__container" ref="container">
      <inline-svg :src="require('@/assets/svg/logo.svg')" />
      <div
        class="header__lang-switch"
        @click="toggleLanguage"
        :class="switchClass"
      >
        {{ getText("header_language_switch") }}
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import ContentMixin from "@/mixins/ContentMixin";
export default {
  name: "Header",
  mixins: [ContentMixin],
  props: {},
  data() {
    return {};
  },
  computed: {
    switchClass() {
      let c = "ar";
      if (this.lang === "ar") c = "en";
      return c;
    },
    lang() {
      return this.$store.getters.lang;
    },
    tb() {
      return this.$store.getters.textbooklet;
    },
  },
  watch: {
    tb() {
      this.$nextTick(() => {
        gsap.set(this.$refs.container, { x: 30 });
        gsap.to(this.$refs.container, { x: 0, duration: 2 });
      });
    },
  },
  methods: {
    toggleLanguage() {
      if (this.$store.getters.lang === "en") {
        this.$router.push("/ar");
        this.$store.commit("set_lang", "ar");
      } else {
        this.$router.push("/en");
        this.$store.commit("set_lang", "en");
      }
    },
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
